import { Col, Input, Row } from "antd";
import { FC, useRef } from "react";

// import "./uploadSalaryRange.less";
import { IModal } from "@types";
import { validateFile } from "@utils";
import UploadModal from "./UploadModal";
import customErrorMessage from "../CustomErrorMessage";

const SAMPLE_FILES_MAP: Record<string, string> = {
  "Upload Job Functions":
    "/samples/Company Job Functions and Job Sub-Functions.csv",
  "Upload Mappings":
    "/samples/Company Job Functions and Job Sub-Functions Mapping.csv",
};

interface IUpload extends IModal {
  onSubmit: any;
  file: File | null;
  title: string;
  setFile: React.Dispatch<React.SetStateAction<File | null>>;
}

const Upload: FC<IUpload> = ({
  isVisible,
  setIsVisible,
  onSubmit,
  file,
  setFile,
  title,
}) => {
  const inputRef = useRef<any>(null);

  const uploadFile = async (event: any) => {
    const selectedFile = event?.target?.files?.[0];

    const error = await validateFile(selectedFile);

    if (error) {
      return customErrorMessage(error);
    }

    setFile(selectedFile);
  };

  const resetFile = () => {
    setFile(null);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  return (
    <UploadModal
      width="w-5/12"
      isVisible={isVisible}
      title={title}
      onClose={() => {
        resetFile();
        setIsVisible(false);
      }}
      footer={
        <div className="flex justify-end gap-2">
          <button
            className="bg-themeOrange text-white font-medium  px-12 h-10 rounded-md"
            onClick={() => {
              resetFile();
              setIsVisible(false);
            }}
          >
            Cancel
          </button>

          <button
            className="bg-themeBlue text-white font-medium px-12 h-10 rounded-md"
            onClick={async () => {
              try {
                await onSubmit();
              } finally {
                resetFile();
                setIsVisible(false);
              }
            }}
            disabled={!file}
          >
            Upload
          </button>
        </div>
      }
    >
      <>
        <Row justify="space-between" className="modal__row">
          <Col className="uploadSalaryRange__uploadField" span={24}>
            <label className="font-semibold  text-base text-themeCore leading-10">
              <span className="text-themeCore">Upload File</span>
            </label>

            <Input
              onClick={() => inputRef.current?.click()}
              size="large"
              readOnly
              accept=".csv"
              className="w-full cursor-pointer borderless-input shadow-sm font-semibold text-sm outline-none border border-themeInputBorder bg-white rounded-md"
              value={file?.name || ""}
              placeholder="Only CSV is supported"
            />

            {/* Download Sample */}
            <div className="mt-2 ml-1">
              <a
                href={SAMPLE_FILES_MAP[title]}
                download
                className="text-themeCore text-xs  underline cursor-pointer"
              >
                Download Sample File
              </a>
            </div>

            <input
              type="file"
              ref={inputRef}
              hidden
              accept=".csv"
              onChange={uploadFile}
            />
          </Col>
        </Row>
      </>
    </UploadModal>
  );
};

export default Upload;
